import { zSession, type Session } from '@cockpit/api-contract'
import { api } from '@/lib/apiClient'
import { parseContract } from './parseContract'

export async function login(payload: { email: string; password: string }): Promise<Session> {
  const { data } = await api.post('/session', payload)
  return parseContract(zSession, data, 'zSession')
}

export async function logout(): Promise<void> {
  await api.delete('/session')
}
